<template>
    <v-container class="header">
        <h1 class="page-heading">Net Metering Scheme</h1>
    </v-container>
    <div>
        <v-container v-if="!userHasAccess">
            <RequestAccess
                desc_text="Would you like to sell your solar energy back to the TNB Grid at a fixed rate?"
                button_text="Yes, apply for the scheme"
                alt_text="Tell me more"
                :feature_name="featureName"
            />
        </v-container>
        <v-container
            v-else
            v-for="align in alignments"
            :key="align"
            class="grey lighten-5 mb-6"
        >
            <v-row no-gutters class="mb-6">
                <v-col>
                    <p class="title font-medium">
                        {{ price }}
                    </p>
                    <p class="font-thin">Total Earnings</p>
                </v-col>
                <v-col>
                    <p class="title font-medium">
                        {{ emissions }}
                    </p>
                    <p class="font-thin">CO2 Emissions Reduced</p>
                </v-col>
            </v-row>
            <div>
                <Line
                    :height="130"
                    :chart-data="chartData"
                    :chart-options="chartOptions"
                    class="net-metering-chart"
                />
            </div>
            <div>
                <v-btn rounded="lg" color="#FFDF8C">
                    Learn more
                    <v-dialog
                        v-model="dialog"
                        max-width="700px"
                        activator="parent"
                    >
                        <v-card>
                            <v-card-text class="text-center">
                                EnergyHub has partnered with Tenaga Nasional
                                Berhad on the Net Metering Scheme which allows
                                Malaysians to
                                <strong
                                    >sell their excess solar energy back to the
                                    grid</strong
                                >, which not only provides an opportunity for
                                Malaysians to
                                <strong>earn additional income</strong> but also
                                <strong
                                    >accelerate the world towards sustainable
                                    energy</strong
                                >. Start selling now!
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="#ffb700"
                                    block
                                    @click="dialog = false"
                                    >I Understand</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>
import { Line } from "vue-chartjs";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
} from "chart.js";
import RequestAccess from "@/components/RequestAccess.vue";
import { computed } from "@vue/runtime-core";
import store from "@/store";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement
);

export default {
    name: "NetMeteringSchemeView",
    components: { Line, RequestAccess },
    props: {
        plugins: {
            type: Array,
            default: () => [Title],
        },
    },
    data: () => ({
        alignments: ["start"],
        price: "RM 212.32",
        emissions: "23%",
        dialog: false,
        chartOptions: {
            elements: {
                line: {
                    tension: 0.3,
                },
            },
            plugins: {
                title: {
                    display: true,
                    text: "Earnings Per Month",
                    padding: {
                        top: 10,
                        bottom: 30,
                    },
                    font: {
                        size: 22,
                        weight: 600,
                    },
                },
                legend: {
                    display: false,
                },
            },
            scales: {
                y: {
                    title: {
                        display: true,
                        text: "MYR",
                        font: {
                            size: 18,
                            weight: 600,
                        },
                    },
                },
                x: {
                    title: {
                        display: true,
                        text: "Month",
                        font: {
                            size: 18,
                            weight: 600,
                        },
                    },
                },
            },
        },
        chartData: {
            labels: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
            ],
            datasets: [
                {
                    label: "Earnings",
                    backgroundColor: "#ffd876",
                    borderColor: "#ffd876",
                    radius: 4,
                    data: [40, 39, 10, 40, 39, 80, 40],
                },
            ],
        },
    }),
    setup() {
        const featureName = "Net Metering Scheme";
        const userHasAccess = computed(
            () => store.state.user?.features?.includes(featureName) || false
        );
        return {
            featureName,
            userHasAccess,
        };
    },
};
</script>

<style lang="scss" scoped>
h1 {
    font-size: 50px;
}
.net-metering-chart {
    padding: 20px;
    border-radius: 18px;
    margin: 40px 0;

    box-shadow: -1px 5px 20px -7px rgba(0, 0, 0, 0.26);
    -webkit-box-shadow: -1px 5px 20px -7px rgba(0, 0, 0, 0.26);
    -moz-box-shadow: -1px 5px 20px -7px rgba(0, 0, 0, 0.26);
}

.header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
}

.text-clickable {
    color: #ffb700;
    font-size: 14px;
    cursor: pointer;
}
</style>
